// extracted by mini-css-extract-plugin
module.exports = {"resetDefault":"breadcrumbs_resetDefault__3kEr2"};